import { Injectable } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { UserPreference } from '../../models';
import * as moment from "moment";
import { CommonService } from '../common.service';
import { appSettings, errorMessages } from "../../settings";
@Injectable()
export class BaseService {

  constructor() { }

  addDataSeries(chartConfig, response, name, chartType, stackBy = '') {
    if (name && chartConfig.legend.data.indexOf(name)<0){
      chartConfig.legend.data.push(name);
    }
    chartConfig.series.push({
      name: name,
      type: chartType,
      barMaxWidth: 20,
      barGap: '5%',
      stack: stackBy,
      itemStyle: {
        emphasis: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowOffsetY: 0,
          shadowColor: 'rgba(0,0,0,0.8)'
        }
      },
      data: response,
    });
  }

  addPieDataSeries(chartConfig: any, response: any, name: string, chartType: string,formatter:string = "{d}%") {
    chartConfig.series.push({
      name: name,
      type: chartType,     
      center: ['50%', '50%'],
      itemStyle: {
        normal:{
            label:{
              show:true,
              formatter : function(param){                
                return param.data.name + " : \n"  + param.data.value + ' (' + param.percent + '%)' ;
              }
            }
          },
          emphasis: {
            show: true,
            position: 'center',
            textStyle: {
              fontSize: '18',
              fontWeight: 'bold'
            }
          }
      },
      data: response,
    });
  }

  addDataSeriesForSecondYAxis(chartConfig, response, name, chartType, stackBy = '', index: number = 0) {
      if (chartConfig.legend.data.indexOf(name)<0){
        chartConfig.legend.data.push(name);
      }
      chartConfig.series.push({
        name: name,
        type: chartType,
        barMaxWidth: 20,
        barGap: '5%',
        stack: stackBy,
        yAxisIndex: index,
        itemStyle: {
          emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: 'rgba(0,0,0,0.8)'
          }
        },
        data: response,
      });
  }

  addDataSeriesDimension(chartConfig, response, name, chartType, stackBy = '', yAxisIndex = 0) {
    if (chartConfig.legend.data.indexOf(name)<0){
      chartConfig.legend.data.push(name);
    }

    chartConfig.series.push({
      name: name,
      type: chartType,
      barMaxWidth: 20,
      barGap: '5%',
      stack: stackBy,
      itemStyle: {
        emphasis: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowOffsetY: 0,
          shadowColor: 'rgba(0,0,0,0.8)'
        }
      },
      yAxisIndex: yAxisIndex,
      data: response,
    });
  }

  addZoomBar(chartConfig) {
    chartConfig.dataZoom = [
      {
        type: 'inside',
        start: 0,
        end: 100
      },
      {
        show: true,
        type: 'slider',
        start: 0,
        end: 100,
        bottom: '0%',
        handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
        handleSize: '60%',
        handleStyle: {
          color: '#fff',
          shadowBlur: 3,
          shadowColor: 'rgba(0, 0, 0, 0.6)',
          shadowOffsetX: 2,
          shadowOffsetY: 2
        }
      }
    ]
  }

  addZoomBarEnd(chartConfig,start = 0, end = 100) {
    chartConfig.dataZoom = [
      {
        type: 'inside',
        start: start,
        end: end
      },
      {
        show: true,
        type: 'slider',
        start: start,
        end: end,
        bottom: '0%',
        handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
        handleSize: '60%',
        handleStyle: {
          color: '#fff',
          shadowBlur: 3,
          shadowColor: 'rgba(0, 0, 0, 0.6)',
          shadowOffsetX: 2,
          shadowOffsetY: 2
        }
      }
    ]
  }

  chartOptions() {
    return {      
      color: ['#3398DB', '#fbb03b', '#8cc63f','#f7935a','#29abe2', '#575560','#0080a8','#22b573', '#44bd54','#998675', '#c7b299', '#fbb03b','#8cc63f', '#44bd54', '#22b573', '#29abe2', '#0080a8'],
      tooltip: {
        trigger: 'axis', 
        formatter: this.tooltipNumberGtZeroFormater,        
        axisPointer: {            
          type: 'shadow'        
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      legend: {
        type: 'scroll',
        data: [],
        textStyle: {
          color: "#fff"
        },
        top: '4%'
      },
      xAxis: {
          type: 'category',
          data: [],
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            interval: 0,
            length: "100%",
            color: "#fff",
            rotate: 0            
          },
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          }
        },
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            interval: 0,
            length: "100%",
            color: "#fff"
          },
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          splitLine: {
            show: false
          },
        }
      ],
      series: []
    };
  } 

  horizontalChartOptions() {
    return {      
      color: ['#3398DB', '#fbb03b', '#8cc63f','#f7935a','#29abe2', '#575560','#0080a8','#22b573', '#44bd54','#998675', '#c7b299', '#fbb03b','#8cc63f', '#44bd54', '#22b573', '#29abe2', '#0080a8'],
      tooltip: {
        trigger: 'axis', 
        formatter: this.tooltipNumberGtZeroFormater,        
        axisPointer: {            
          type: 'shadow'        
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      legend: {
        type: 'scroll',
        data: [],
        textStyle: {
          color: "#fff"
        },
        top: '4%'
      },
      yAxis: {
          type: 'category',
          data: [],
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            interval: 0,
            length: "100%",
            color: "#fff",
            rotate: 0            
          },
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          }
        },
      xAxis: [
        {
          type: 'value',
          axisLabel: {
            interval: 0,
            length: "100%",
            color: "#fff"
          },
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          splitLine: {
            show: false
          },
        }
      ],
      series: []
    };
  } 

  PieChartOptions() {    
    return {    
      color: ['#8cc63f', '#29abe2', '#e3ed74', '#44bd54', '#0080a8','#3398DB', '#fbb03b', 
              '#f7935a', '#575560','#22b573', '#998675','#c7b299',  '#22b573'],
      tooltip: {
        trigger: "item",
        formatter: function(item)  { return new Intl.NumberFormat('en-US').format(item.data.value);}
      },
      title: {
        left: 'left',
        text: '',
        subtext:''
      },     
      grid: {
        bottom: 28,
      },
      legend: {
        type: 'scroll',
        textStyle: {
          color: "#fff"
        },
        bottom: 10,
        left: 'center'
      },
      toolbox:{},
      series: []
    };
  }

  customizeChartOptions(axisName: string = '',axisPercent:boolean = false) {
    return {      
      color: ['#3398DB', '#fbb03b', '#8cc63f', '#44bd54', '#22b573', '#29abe2', '#0080a8', '#575560', '#998675', '#c7b299', '#f7935a', '#fbb03b', '#8cc63f', '#44bd54', '#22b573', '#29abe2', '#0080a8'],
      tooltip: {
        trigger: 'axis',        
        formatter: this.tooltipPercentFormat,
        axisPointer: {            
          type: 'shadow'        
        }
      },
      grid: {
        left: '6%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      legend: {
        type: 'scroll',
        data: [],
        textStyle: {
          color: "#fff"
        },
        top: '4%'
      },
      xAxis: {
          type: 'category',
          data: [],
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            interval: 0,
            length: "100%",
            color: "#fff",
            rotate: 0            
          },
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          }
        },
      yAxis: [
        {
          name: axisName,
          nameLocation: 'center',
          nameGap: 50,
          type: 'value',
          axisLabel: {
            interval: 0,
            length: "100%",
            color: "#fff",
            formatter: function(value){
              let v:string = '';
              v = value.toString();
              if(axisPercent){
                v = v + '%';
              }
              return v;
            }
          },
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          splitLine: {
            show: false
          },
        }
      ],
      series: []
    };
  }

  getSecondYAxis(axisName: string = '',axisPercent:boolean = false): any {
    return {
      name: axisName,
      nameLocation: 'center',
      nameGap: 50,
      type: 'value',
      axisLabel: {
        interval: 0,
        length: "100%",
        color: "#fff",
        formatter: function(value){
          let v:string = '';
          v = value.toString();
          if(axisPercent){
            v = v + '%';
          }
          return v;
        }
      },
      axisLine: {
        lineStyle: {
          color: '#fff'
        }
      },
      splitLine: {
        show: false
      },
    }
  }

  tooltipPercentFormat(params): string {
    let tip: string = '';
    if (Array.isArray(params) && params.length > 0) {
      tip = tip + params[0].axisValue + '</br>';
      params.forEach(function (item) {
        if (item.data != null) {
          tip = tip + '<span style="display:inline-block;margin-left:5px;margin-right:5px;'
            + 'border-radius:10px;width:9px;height:9px;background-color:'
            + item.color + ';"></span>' + item.seriesName + ' : ' + item.data + '%</br>';
        }
      });
    }
    return tip;
  }

  tooltipNumberGtZeroFormater(params): string {
    let tip: string = '';
    if (Array.isArray(params) && params.length > 0) {
      tip = tip + params[0].axisValue + '</br>';
      params.forEach(function (item) {
        if (item.data != null) {
          tip = tip + '<span style="display:inline-block;margin-left:5px;margin-right:5px;'
            + 'border-radius:10px;width:9px;height:9px;background-color:'
            + item.color + ';"></span>' + item.seriesName + ' : ' + item.data + '</br>';
        }
      });
    }
    return tip;
  }

  tooltipNameValueFormater(params): string {
    let tip: string = '';
    if (Array.isArray(params) && params.length > 0) {
      tip = tip + params[0].axisValue + '</br>';
      params.forEach(function (item) {
        if (item.data != null) {
          tip = tip + '<span style="display:inline-block;margin-left:5px;margin-right:5px;'
            + 'border-radius:10px;width:9px;height:9px;background-color:'
            + item.color + ';"></span>' + item.data.name + '-' 
            + item.seriesName + ' : ' + item.data.value + '</br>';
        }
      });
    }
    return tip;
  }

  toolTipNumberFormatter(params): string {
    let tip: string = '';
    if (Array.isArray(params) && params.length > 0) {
      tip = tip + params[0].axisValue + '</br>';
      params.forEach(function (item) {
        if (item.data != null) {
          tip = tip + '<span style="display:inline-block;margin-left:5px;margin-right:5px;'
            + 'border-radius:10px;width:9px;height:9px;background-color:'
            + item.color + ';"></span>' + item.seriesName + ' : ' + item.data[1] + '</br>';
        }
      });
    }
    return tip;
  }

  //Method will handle special case where tool tip is different than x and y axis values
  tooltipDiffValueFormater(params): string {
    let tip: string = '';
    if (Array.isArray(params) && params.length > 0) {      
      params.forEach(function (item) {
        if (item.data != null && item.data.length >= 4) {
          tip = tip + '<span style="display:inline-block;margin-left:5px;margin-right:5px;'
            + 'border-radius:10px;width:9px;height:9px;background-color:'
            + item.color + ';"></span>' + item.seriesName + ' ' + item.data[0] + ' : ' 
            + item.data[2] + ' , ' + item.data[3] + '</br>';
        }
      });
    }
    return tip;
  }

  //Method will handle special case where tool tip is different than x and y axis values
  tooltipShortedFormater(params): string {
    let tip: string = '';
    if (Array.isArray(params) && params.length > 0) {      
      params.forEach(function (item) {
        if (item.data != null && item.data.length >= 4) {
          tip = tip + '<span style="display:inline-block;margin-left:5px;margin-right:5px;'
            + 'border-radius:10px;width:9px;height:9px;background-color:'
            + item.color + ';"></span>' + item.data[0] + ', ' + item.seriesName + ' ' + item.data[1] + '%' + '</br>' + item.data[2] + ' , ' 
            + item.data[3] + '</br>';
        }
      });
    }
    return tip;
  }

  pieChartTooltipFormatter(param): string {
    if(param && param.data){
      return  param.data.name + ' : ' + param.data.value + ' (' + param.percent + '%)' ;  
    }    
    return "";
  }
}



// WEBPACK FOOTER //
// ./src/app/services/widgets/base.service.ts